import script from "./H2hList.vue?vue&type=script&setup=true&lang=ts"
export * from "./H2hList.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__